import React from 'react';
import { ThreeBounce } from 'better-react-spinkit';

interface SpinnerProps {
  size?: number;
  color?: string;
  scaleStart?: number;
  scaleEnd?: number;
  positionAbsolute?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 15, color = '#429ccc' }) => {
  return (
    <div className="Spinner">
      <ThreeBounce size={size} color={color} />
    </div>
  );
};

export { Spinner };
